import React, { useMemo } from "react";
import { createPath, Navigate, parsePath, useLocation } from "react-router-dom";

type NavigateProps = React.ComponentProps<typeof Navigate>;

const mergeSearchParams = (currentSearch: string, destinationSearch: string) => {
  const mergedParams = new URLSearchParams(currentSearch);
  new URLSearchParams(destinationSearch).forEach((value, key) => mergedParams.set(key, value));

  const search = mergedParams.toString();
  return search ? `?${search}` : "";
};

const preserveSearch = (to: NavigateProps["to"], currentSearch: string): NavigateProps["to"] => {
  if (!currentSearch) return to;

  if (typeof to === "string") {
    const destination = parsePath(to);
    return createPath({ ...destination, search: mergeSearchParams(currentSearch, destination.search ?? "") });
  }

  return {
    ...to,
    search: mergeSearchParams(currentSearch, to.search ?? ""),
  };
};

export const SearchPreservingNavigate: React.FC<NavigateProps> = ({ to, ...navigateProps }) => {
  const { search } = useLocation();
  const destination = useMemo(() => preserveSearch(to, search), [to, search]);

  return <Navigate {...navigateProps} to={destination} />;
};
